<template>
  <div class="flex flex-col gap-3" data-cy="contract-signed-app-download">
    <AtomText
      :text="t('subscription.contractSigned.appDownload.title')"
      font-size="text-lg"
      font-style="font-semibold"
    />
    <div class="grid gap-4 sm:grid-cols-2">
      <div
        class="flex items-center justify-between gap-3 rounded-lg border border-cime-gray-lighter p-4"
        data-cy="contract-signed-app-download-apple"
      >
        <div class="flex flex-col items-start gap-2">
          <AtomText
            :text="t('subscription.contractSigned.appDownload.apple.heading')"
            font-size="text-sm"
          />
          <img
            :src="appStoreBadge"
            :alt="t('subscription.contractSigned.appDownload.apple.heading')"
            class="h-[42px] w-auto cursor-pointer"
            data-cy="contract-signed-app-download-apple-link"
            @click="openAppleStore"
          />
        </div>
        <img :src="appleQrCode" alt="appleQrCode" class="size-[70px] shrink-0" />
      </div>

      <div
        class="flex items-center justify-between gap-3 rounded-lg border border-cime-gray-lighter p-4"
        data-cy="contract-signed-app-download-google"
      >
        <div class="flex flex-col items-start gap-2">
          <AtomText
            :text="t('subscription.contractSigned.appDownload.google.heading')"
            font-size="text-sm"
          />
          <img
            :src="googlePlayBadge"
            :alt="t('subscription.contractSigned.appDownload.google.heading')"
            class="h-[42px] w-auto cursor-pointer"
            data-cy="contract-signed-app-download-google-link"
            @click="openGooglePlay"
          />
        </div>
        <img :src="androidQrCode" alt="androidQrCode" class="size-[70px] shrink-0" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';

import appStoreBadge from '@/assets/images/subscription/appStoreBadge.svg';
import googlePlayBadge from '@/assets/images/subscription/googlePlayBadge.svg';
import androidQrCode from '@/assets/images/subscription/QR-code-Android.png';
import appleQrCode from '@/assets/images/subscription/QR-code-iOS.png';

const openAppleStore = () => {
  window.open('https://apps.apple.com/fr/app/mylight150/id6474870742', '_blank');
};

const openGooglePlay = () => {
  window.open('https://play.google.com/store/apps/details?id=com.mylightsystems.mira', '_blank');
};

const { t } = useI18n();
</script>

<style scoped></style>
